import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Paper } from '@material-ui/core';
import MaterialTable from 'material-table';
import { H4 } from '@blueprintjs/core';

class InnerCollocsDetailsPopup extends React.PureComponent {

  state = {
     
  }


  render() {
        const { t,data,realization } = this.props;
        const tableData=[];
        console.log("InnerCollocsDataPairs=",data);

        for (const line of data) {
            const row = {
              leaf: line[0],
              tree:  line[1],
              assoc: line[2],
            };
            tableData.push(row)
        }

        return (
                <>
                    <br/>
                    <center><H4>{realization}</H4></center>
                    <br/>
                    <MaterialTable
                        columns={[
                            { 
                                title: t('leaf'), 
                                field: 'leaf', 
                            },
                            { 
                                title: t('tree'), 
                                field: 'tree', 
                            },                            
                            { 
                                title: t('assoc'), 
                                field: 'assoc', 
                            },                            
                        ]}
                        data={tableData}
                        title={" "}
                        options={{
                            filtering: false,
                            search: false,
                            sorting: true,
                            exportButton: true,
                            exportFileName:`assocMeasureForEachComponent`,
                        }}
                        components={{
                            Container: props => (
                                <Paper
                                    {...props}
                                    elevation={0}
                                />
                            ),
                        }}
                    />
                    <br/>
                    
                </>
               
        );
       
    }
}

InnerCollocsDetailsPopup.propTypes = {
        // see prepCoocData for an example
        data: PropTypes.array,
        realization : PropTypes.string
};

export default withTranslation()(InnerCollocsDetailsPopup);
